import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["referrer"];
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { observable, action, computed, reaction, runInAction } from 'mobx';
import { task } from 'mobx-task';
import { validationContext, required, pattern, func } from 'validx';
import { ignore404, populateValidationContextFromError, extractMessageFromError } from '../utils/errorUtil';
import { containsOnlyValidPhoneNumberChars } from '../utils/phoneNumberValidationUtil';
var WorkspaceSelectorStore = (_dec = task.resolved, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _dec6 = action.bound, _dec7 = task.resolved, _dec8 = task.resolved, _class = /*#__PURE__*/function (_Store) {
  function WorkspaceSelectorStore() {
    var _this;
    _classCallCheck(this, WorkspaceSelectorStore);
    _this = _callSuper(this, WorkspaceSelectorStore, arguments);
    _initializerDefineProperty(_this, "view", _descriptor, _this);
    _initializerDefineProperty(_this, "workspace", _descriptor2, _this);
    _initializerDefineProperty(_this, "givenName", _descriptor3, _this);
    _initializerDefineProperty(_this, "familyName", _descriptor4, _this);
    _initializerDefineProperty(_this, "email", _descriptor5, _this);
    _initializerDefineProperty(_this, "phone", _descriptor6, _this);
    _initializerDefineProperty(_this, "domain", _descriptor7, _this);
    _initializerDefineProperty(_this, "showing", _descriptor8, _this);
    _initializerDefineProperty(_this, "canGoBack", _descriptor9, _this);
    _initializerDefineProperty(_this, "searchError", _descriptor10, _this);
    _initializerDefineProperty(_this, "searchText", _descriptor11, _this);
    _initializerDefineProperty(_this, "inviteToPath", _descriptor12, _this);
    _this.validation = validationContext(_this, {
      givenName: [required(), func(function (_ref) {
        var value = _ref.value;
        return value.length <= 40 || "Given name can't be more than 40 characters";
      }), func(function (_ref2) {
        var value = _ref2.value;
        return value.trim() !== '' || 'This field is required';
      })],
      familyName: [required(), func(function (_ref3) {
        var value = _ref3.value;
        return value.length <= 40 || "Family name can't be more than 40 characters";
      }), func(function (_ref4) {
        var value = _ref4.value;
        return value.trim() !== '' || 'This field is required';
      })],
      email: [required(), pattern('email'), func(function (_ref5) {
        var value = _ref5.value;
        return value.length <= 320 || "Email can't be more than 320 characters";
      })],
      phone: [required(), func(function (_ref6) {
        var value = _ref6.value;
        return value.length <= 20 || "Phone can't be more than 20 characters";
      }), func(function (opts) {
        return containsOnlyValidPhoneNumberChars(opts.value);
      }, 'Phone numbers must contain only numbers (at least three), an optional "+" at the start, one set of optional parentheses, and non-consecutive uses of ( ) + - /')]
    });
    _this.selectWorkspace = _this.selectWorkspace.wrap(action).bind(_this);
    _this.lookupWorkspaceByDomain = _this.lookupWorkspaceByDomain.bind(_this).wrap(action);
    _this.showSelector();
    reaction(function () {
      return _this.domain;
    }, _this.lookupWorkspaceByDomain, {
      delay: 200
    });
    return _this;
  }

  /**
   * Determines feedback for WorkspaceSearch
   */
  _inherits(WorkspaceSelectorStore, _Store);
  return _createClass(WorkspaceSelectorStore, [{
    key: "domainCheck",
    value: function domainCheck() {
      if (this.workspace) {
        return ' correct';
      } else if (this.searchError) {
        return ' error';
      } else {
        return '';
      }
    }

    /**
     * Getter for the workspace that matches the current domain, if any.
     */
  }, {
    key: "domainMatchedWorkspace",
    get: function get() {
      return this.rootStore.workspaceStore.workspaces.find(function (x) {
        return x.isDomainMatchedWorkspace;
      });
    }

    /**
     * The current user's workspace memberships.
     */
  }, {
    key: "memberships",
    get: function get() {
      return this.rootStore.userStore.memberships.slice();
    }

    /**
     * The current user's workspace memberships.
     */
  }, {
    key: "filteredMemberships",
    get: function get() {
      var _this2 = this;
      return this.rootStore.userStore.memberships.slice().filter(function (x) {
        return x.workspace.name.toLowerCase().includes(_this2.searchText.toLowerCase()) || x.workspace.slug.toLowerCase().includes(_this2.searchText.toLowerCase());
      });
    }

    /**
     * The selector cannot be closed if a workspace and a member has not been selected.
     */
  }, {
    key: "canCloseSelector",
    get: function get() {
      var sessionStore = this.rootStore.sessionStore;
      return Boolean(sessionStore.workspace && sessionStore.member && sessionStore.member.id);
    }

    /**
     * Activates the store, initializing all the things.
     */
  }, {
    key: "activate",
    value: (function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(invitationToken) {
        var _this3 = this;
        var memberships;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              runInAction(function () {
                _this3.email = _this3.rootStore.sessionStore.user.email;
                _this3.givenName = _this3.rootStore.sessionStore.user.givenName;
                _this3.familyName = _this3.rootStore.sessionStore.user.familyName;
                _this3.phone = _this3.rootStore.sessionStore.user.phone;
              });
              _context.next = 3;
              return this.rootStore.userStore.fetchWorkspaceMemberships();
            case 3:
              memberships = _context.sent;
              if (memberships.length === 0 && !invitationToken) {
                if (!this.domainMatchedWorkspace) {
                  this.showWorkspaceSearch();
                } else {
                  this.selectWorkspace(this.domainMatchedWorkspace);
                }
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate(_x) {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
    /**
     * Initializes the selector from the environment, pre-selecting the workspace matching the
     * domain and restoring the selected workspace of a reloaded tab.
     */
    )
  }, {
    key: "initializeFromEnvironment",
    value: (function () {
      var _initializeFromEnvironment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(invitationToken, workspaceSlug) {
        var _this$rootStore, workspaceStore, userStore, workspace, lastSelectedWorkspaceId, memberships;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$rootStore = this.rootStore, workspaceStore = _this$rootStore.workspaceStore, userStore = _this$rootStore.userStore;
              workspace = workspaceStore.workspaces.find(function (x) {
                return x.isDomainMatchedWorkspace;
              });
              if (!workspace) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return this.selectWorkspace(workspace);
            case 5:
              _context2.next = 24;
              break;
            case 7:
              if (!workspaceSlug) {
                _context2.next = 12;
                break;
              }
              _context2.next = 10;
              return this.selectWorkspace(workspaceSlug);
            case 10:
              _context2.next = 24;
              break;
            case 12:
              lastSelectedWorkspaceId = this._getLastSelectedWorkspace();
              if (!lastSelectedWorkspaceId) {
                _context2.next = 18;
                break;
              }
              _context2.next = 16;
              return this.selectWorkspace(lastSelectedWorkspaceId);
            case 16:
              _context2.next = 24;
              break;
            case 18:
              _context2.next = 20;
              return userStore.fetchWorkspaceMemberships();
            case 20:
              memberships = _context2.sent;
              if (!(memberships.length === 1)) {
                _context2.next = 24;
                break;
              }
              _context2.next = 24;
              return this.selectWorkspace(memberships[0].workspace);
            case 24:
              if (!invitationToken) {
                _context2.next = 27;
                break;
              }
              _context2.next = 27;
              return this.fetchInvitation(invitationToken);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function initializeFromEnvironment(_x2, _x3) {
        return _initializeFromEnvironment.apply(this, arguments);
      }
      return initializeFromEnvironment;
    }()
    /**
     * Fetches the invitation by token.
     * This will select that workspace, populate the email field on the signup
     * in case the user is not a member. If they are, we accept the invite immediately
     * @param {*} token
     */
    )
  }, {
    key: "fetchInvitation",
    value: (function () {
      var _fetchInvitation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(token) {
        var _this4 = this;
        var invitation, workspace;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.inviteToken = token;
              _context3.next = 3;
              return this.rootStore.invitationStore.get(token);
            case 3:
              invitation = _context3.sent;
              if (!(invitation.status !== 'PENDING')) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              runInAction(function () {
                _this4.email = invitation.email;
              });
              _context3.next = 9;
              return this.rootStore.workspaceStore.fetchWorkspace(invitation.workspace_id, {
                include_domains: true
              });
            case 9:
              workspace = _context3.sent;
              _context3.next = 12;
              return this.selectWorkspace(workspace);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchInvitation(_x4) {
        return _fetchInvitation.apply(this, arguments);
      }
      return fetchInvitation;
    }()
    /**
     * Selects a workspace and decides whether to select the workspace in
     * the session store, or if we need to create a member first.
     *
     * @param {*} workspace
     */
    )
  }, {
    key: "selectWorkspace",
    value: (function () {
      var _selectWorkspace = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(workspace) {
        var _this5 = this;
        var _this$rootStore2, sessionStore, memberStore, workspaceStore, trackingStore, userStore, flashMessageStore, invitation, team, member;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (workspace) {
                _context4.next = 3;
                break;
              }
              this.searchError = true;
              return _context4.abrupt("return");
            case 3:
              _this$rootStore2 = this.rootStore, sessionStore = _this$rootStore2.sessionStore, memberStore = _this$rootStore2.memberStore, workspaceStore = _this$rootStore2.workspaceStore, trackingStore = _this$rootStore2.trackingStore, userStore = _this$rootStore2.userStore, flashMessageStore = _this$rootStore2.flashMessageStore;
              if (!(typeof workspace === 'string')) {
                _context4.next = 10;
                break;
              }
              _context4.next = 7;
              return workspaceStore.fetchWorkspace(workspace, {
                include_domains: true
              }).catch(function (err) {
                flashMessageStore.create({
                  type: 'error',
                  message: "".concat(extractMessageFromError(err))
                });
                console.error(err);
              });
            case 7:
              workspace = _context4.sent;
              _context4.next = 13;
              break;
            case 10:
              _context4.next = 12;
              return workspaceStore.fetchWorkspace(workspace.id, {
                include_domains: true
              }).catch(function (err) {
                flashMessageStore.create({
                  type: 'error',
                  message: "".concat(extractMessageFromError(err))
                });
                console.error(err);
              });
            case 12:
              workspace = _context4.sent;
            case 13:
              if (workspace) {
                _context4.next = 17;
                break;
              }
              this._removeLastSelectWorkspace();
              userStore.fetchWorkspaceMemberships.clear();
              return _context4.abrupt("return");
            case 17:
              runInAction(function () {
                _this5.workspace = workspace;
                _this5._setLastSelectedWorkspace(_this5.workspace.id);
              });
              if (!this.inviteToken) {
                _context4.next = 33;
                break;
              }
              _context4.next = 21;
              return this.rootStore.invitationStore.get(this.inviteToken);
            case 21:
              invitation = _context4.sent;
              _context4.next = 24;
              return this.rootStore.teamStore.teams.get(invitation.team_id);
            case 24:
              team = _context4.sent;
              if (!(invitation.status === 'PENDING')) {
                _context4.next = 32;
                break;
              }
              _context4.next = 28;
              return this.acceptInvitation().then(function () {
                _this5.rootStore.flashMessageStore.create({
                  type: 'success',
                  message: "You are officially a member of ".concat(team && 'team ' + team.name || workspace.name, "!")
                }).autoDismiss(10000);
              });
            case 28:
              this.inviteToken = null;
              team && (this.inviteToPath = '/teams');
              _context4.next = 33;
              break;
            case 32:
              if (invitation.status === 'ACCEPTED') {
                this.rootStore.flashMessageStore.create({
                  type: 'error',
                  message: "Could not process invitation!"
                }).autoDismiss(10000);
              } else {
                this.inviteToken = null;
              }
            case 33:
              _context4.next = 35;
              return memberStore.fetchByPublicId({
                workspace_id: workspace.id,
                user_public_id: sessionStore.user.userPublicId
              });
            case 35:
              member = _context4.sent;
              if (!(!member || !member.id)) {
                _context4.next = 43;
                break;
              }
              if (!this.validation.reset().validate().isValid) {
                _context4.next = 39;
                break;
              }
              return _context4.abrupt("return", this.createMember());
            case 39:
              // reset the validation to not show error messages right away
              this.validation.reset();
              // The user does not really exist (no ID),
              // so we need to ask them to fill out their profile,
              // thus creating a member.
              return _context4.abrupt("return", this.showProfileStep(true));
            case 43:
              if (!(
              // The user exists but we dont have names and emails
              member.givenName.length === 0 || member.familyName.length === 0 || member.email.length === 0)) {
                _context4.next = 47;
                break;
              }
              return _context4.abrupt("return", this.showProfileStep(false));
            case 47:
              trackingStore && trackingStore.track('Workspace Selected (Login)', {
                first_name: member.givenName,
                last_name: member.familyName,
                email: member.email,
                workspace_id: workspace.id
              });
            case 48:
              this._checkRedirect(workspace);

              // The workspace and member exists, so we can select it in the session store.
              // This will make the WorkspaceGateway render the actual app.
              _context4.next = 51;
              return sessionStore.selectWorkspace(workspace);
            case 51:
              this.closeSelector();
            case 52:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function selectWorkspace(_x5) {
        return _selectWorkspace.apply(this, arguments);
      }
      return selectWorkspace;
    }())
  }, {
    key: "setSearchText",
    value: function setSearchText(searchText) {
      this.searchText = searchText;
    }
  }, {
    key: "showSelector",
    value: function showSelector() {
      this.workspace = null;
      this.showing = true;
      this.view = 'selector';
    }
  }, {
    key: "showProfileStep",
    value: function showProfileStep() {
      var canGoBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.showing = true;
      this.view = 'profile';
      this.canGoBack = canGoBack;
    }
  }, {
    key: "showWorkspaceSearch",
    value: function showWorkspaceSearch() {
      this.showing = true;
      this.view = 'search';
    }
  }, {
    key: "dismissError",
    value: function dismissError() {
      this.domain = '';
      this.showSelector();
      this.selectWorkspace.reset();
    }
  }, {
    key: "closeSelector",
    value: function closeSelector() {
      this.showing = false;
    }
  }, {
    key: "createMember",
    value: function () {
      var _createMember = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this6 = this;
        var _this$rootStore3, sessionStore, memberStore, workspaceStore, userStore, trackingStore, _ref7, referrer, referrerMeta, workspace, member, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this.validation.reset().validate().isValid === false)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _this$rootStore3 = this.rootStore, sessionStore = _this$rootStore3.sessionStore, memberStore = _this$rootStore3.memberStore, workspaceStore = _this$rootStore3.workspaceStore, userStore = _this$rootStore3.userStore, trackingStore = _this$rootStore3.trackingStore;
              _ref7 = JSON.parse(window.localStorage.getItem('referrerMeta')) || '{}', referrer = _ref7.referrer, referrerMeta = _objectWithoutProperties(_ref7, _excluded);
              window.localStorage.removeItem('referrerMeta');
              workspace = this.workspace;
              _context5.next = 8;
              return memberStore.fetchByPublicId({
                workspace_id: workspace.id,
                user_public_id: sessionStore.user.userPublicId
              });
            case 8:
              member = _context5.sent;
              if (!(!member || !member.id)) {
                _context5.next = 17;
                break;
              }
              data = {
                workspace_id: workspace.id,
                user_id: sessionStore.user.userId,
                user_public_id: sessionStore.user.userPublicId,
                given_name: this.givenName.trim(),
                family_name: this.familyName.trim(),
                email: this.email,
                phone: this.phone,
                referrer: referrer || '',
                referrer_metadata: referrerMeta || {}
              }; // Create the member.
              _context5.next = 13;
              return memberStore.create(data).catch(function (error) {
                populateValidationContextFromError(_this6.validation, error, 'camel');
                throw error;
              });
            case 13:
              member = _context5.sent;
              trackingStore && trackingStore.accountSignup(data);
              _context5.next = 20;
              break;
            case 17:
              _context5.next = 19;
              return memberStore.update({
                workspace_id: workspace.id,
                user_id: sessionStore.user.userId
              }, {
                given_name: this.givenName.trim(),
                family_name: this.familyName.trim(),
                email: this.email,
                phone: this.phone
              }).catch(function (error) {
                populateValidationContextFromError(_this6.validation, error, 'camel');
                throw error;
              });
            case 19:
              member = _context5.sent;
            case 20:
              _context5.next = 22;
              return userStore.fetch(member.userId);
            case 22:
              this._checkRedirect(workspace);

              // If a member was created, then member-only info for a workspace has not been
              // returned, so clear the fetch cache for the workspace so the next fetch will
              // hit the API.
              workspaceStore.clearFetchCacheFor(workspace.id);
              userStore.addMembership({
                workspace: workspace,
                member: member
              });
              _context5.next = 27;
              return this.selectWorkspace(this.workspace);
            case 27:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createMember() {
        return _createMember.apply(this, arguments);
      }
      return createMember;
    }()
    /**
     * Accepts an invitation.
     */
  }, {
    key: "acceptInvitation",
    value: (function () {
      var _acceptInvitation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(props) {
        var member;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.rootStore.invitationStore.accept(_objectSpread({
                token: this.inviteToken
              }, props));
            case 2:
              member = _context6.sent;
              return _context6.abrupt("return", this.rootStore.memberStore.members.set(member));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function acceptInvitation(_x6) {
        return _acceptInvitation.apply(this, arguments);
      }
      return acceptInvitation;
    }())
  }, {
    key: "lookupWorkspaceByDomain",
    value: function () {
      var _lookupWorkspaceByDomain = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(domain) {
        var _this7 = this;
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.searchError = false;
              if (domain) {
                _context7.next = 4;
                break;
              }
              this.workspace = null;
              return _context7.abrupt("return");
            case 4:
              _context7.next = 6;
              return this.rootStore.workspaceStore.fetchByDomain(domain).catch(ignore404);
            case 6:
              result = _context7.sent;
              runInAction(function () {
                _this7.workspace = result;
              });
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function lookupWorkspaceByDomain(_x7) {
        return _lookupWorkspaceByDomain.apply(this, arguments);
      }
      return lookupWorkspaceByDomain;
    }()
  }, {
    key: "_getLastSelectedWorkspace",
    value: function _getLastSelectedWorkspace() {
      return window.sessionStorage.getItem('lastWorkspaceId') || null;
    }
  }, {
    key: "_setLastSelectedWorkspace",
    value: function _setLastSelectedWorkspace(workspaceId) {
      window.sessionStorage.setItem('lastWorkspaceId', workspaceId);
    }
  }, {
    key: "_removeLastSelectWorkspace",
    value: function _removeLastSelectWorkspace() {
      window.sessionStorage.removeItem('lastWorkspaceId');
    }
  }, {
    key: "_checkRedirect",
    value: function _checkRedirect(workspace) {
      var redirectUrl = window.localStorage.getItem('redirectUrl') || '';
      if (redirectUrl) {
        window.localStorage.removeItem('redirectUrl');
        var separator = redirectUrl.indexOf('?') > -1 ? '&' : '?';
        window.location.replace("".concat(redirectUrl).concat(separator, "workspace_id=").concat(workspace.id, "&user_id=").concat(this.rootStore.sessionStore.user.userId));
      }
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "view", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "workspace", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "givenName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "familyName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "domain", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "canGoBack", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "searchError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "searchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "inviteToPath", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '/';
  }
}), _applyDecoratedDescriptor(_class.prototype, "domainMatchedWorkspace", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "domainMatchedWorkspace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "memberships", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "memberships"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredMemberships", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredMemberships"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canCloseSelector", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canCloseSelector"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeFromEnvironment", [task], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFromEnvironment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectWorkspace", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "selectWorkspace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSearchText", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSearchText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSelector", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "showSelector"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showProfileStep", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showProfileStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWorkspaceSearch", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "showWorkspaceSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismissError", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "dismissError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeSelector", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "closeSelector"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMember", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "createMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lookupWorkspaceByDomain", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "lookupWorkspaceByDomain"), _class.prototype), _class);
export { WorkspaceSelectorStore as default };
//# sourceMappingURL=WorkspaceSelectorStore.js.map
